import React, {useState} from 'react';
import Button from "../button";

const Results = (props) => {

    const [originators, setOriginators] = useState([]);
    const [offers, setOffers] = useState(null);

    const disclaimerRef = React.useRef([]);

    React.useEffect(() => {
        if (props.results.loanOffers.length > 0) {
            // console.log('OFFERS EXIST')
            buildOriginators(props.results.loanOffers)
        }
        // console.log('results: ', props.results)
    }, [props.results]);


    React.useEffect(() => {
        if (originators.length > 0) {
            buildOffersByOriginator(props.results.loanOffers)
        }
    }, [originators]);


    const buildOriginators = (offers) => {
        let originators = [];
        offers.forEach(o => {
            originators.push(o.originator.key)
        })
        const unique_originators = originators.filter(distinct);
        setOriginators(unique_originators)
    }

    const distinct = (val, ind, self) => {
        return self.indexOf(val) === ind
    }

    const buildOffersByOriginator = (loanOffers) => {
        let grouped_offers = [];
        originators.forEach(originator => {
            grouped_offers[originator] = loanOffers.filter(offer =>
                offer.originator.key === originator
            )
        });
        setOffers(grouped_offers)
    }

    const expandDisclaimer = (e, i) => {
        e.preventDefault();
        if (disclaimerRef.current[i].children[1].classList.contains('hide')) {
            disclaimerRef.current[i].children[1].classList.remove('hide')
            disclaimerRef.current[i].children[0].classList.add('hide')
        } else {
            disclaimerRef.current[i].children[1].classList.add('hide')
            disclaimerRef.current[i].children[0].classList.remove('hide')
        }


    }

    const buildOffers = (loanOffer, index) => {
        const totalOffers = loanOffer.length - 1;
        return loanOffer.map((o, i) =>
            (
                <>
                    <div className="originator__logo--mobile">
                        {
                            i === 0 &&
                            <img src={o.originator.images[0]['url']} alt={o.originator.key}/>
                        }
                    </div>

                    <div className="originator" key={i}>
                        <div className="originator__logo">
                            {
                                i === 0 &&
                                <img src={o.originator.images[0]['url']} alt={o.originator.key}/>
                            }
                        </div>
                        <div className="originator__result">
                            <div className="originator__result-title">Amount</div>
                            <div className="originator__result-value">
                                ${o.maxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </div>

                        </div>
                        <div className="originator__result">
                            <div className="originator__result-title">APR</div>
                            <div className="originator__result-value">{o.maxApr}%</div>
                        </div>
                        <div className="originator__result">
                            <div className="originator__result-title">Monthly Payment</div>
                            <div className="originator__result-value">${o.monthlyPayment}</div>
                        </div>
                        <div className="originator__result">
                            <div className="originator__result-title">Term</div>
                            <div className="originator__result-value">{o.termLength} {o.termUnit}</div>
                        </div>
                        <div className="originator__button">
                            <Button
                                buttonText={"Select"}
                                buttonColorBg={"transparent"}
                                arrowColor={'#fff'}
                                buttonHoverColor={"#A26C1D"}
                                fontColor={"#A26C1D"}
                                fontHoverColor={"#fff"}
                                fontSize={'18px'}
                                buttonWidth={'120px'}
                                buttonHeight={'40px'}
                                buttonBorderWidth={'2px'}
                                linkTarget={'_blank'}
                                linkDestination={o.url}
                                external
                            />
                        </div>
                    </div>
                    {
                        i === totalOffers &&
                        <div ref={ref => {
                            disclaimerRef.current[index] = ref
                        }}
                             className="originator__read-disclaimer pt-4">
                            <div className="pointer text-center pb-4" onClick={(e) => expandDisclaimer(e, index)}>
                                + see more details and disclosure
                            </div>
                            <div className="originator__disclaimer hide">
                                <div className="pointer text-center pb-4" onClick={(e) => expandDisclaimer(e, index)}>
                                    - hide details and disclosure
                                </div>
                                {o.originator.disclaimer}
                            </div>
                        </div>
                    }
                </>
            )
        )
    };


    return (
        <>
            <div className="results">
                {
                    offers ?
                        <>
                            <div className="section-title_text">
                                Here are your<br/>
                                <span>Personalized Loan Offers</span>
                            </div>
                            {
                                Object.keys(offers).map((o, i) => {
                                    return <div className="result__container">
                                        {buildOffers(offers[o], i)}
                                    </div>

                                })
                            }
                        </>
                        :
                        <>
                            <div className="section-title_text">
                                <span>Oh No!</span><br/>
                                <h3>
                                    Unfortunately, there are no offers available for you
                                    at this time.
                                </h3>
                            </div>
                            <div className="result__container">
                                <Button
                                    buttonText={"Apply Again"}
                                    buttonColorBg={"transparent"}
                                    arrowColor={'#fff'}
                                    buttonHoverColor={"#A26C1D"}
                                    fontColor={"#A26C1D"}
                                    fontHoverColor={"#fff"}
                                    fontSize={'18px'}
                                    buttonWidth={'240px'}
                                    buttonHeight={'60px'}
                                    buttonBorderWidth={'2px'}
                                    linkTarget={'_self'}
                                    linkDestination={''}
                                    submit
                                    callback={() => props.resetForm()}
                                />
                            </div>
                        </>
                }
            </div>
        </>
    )
}

export default Results;
